"use strict";

require("core-js/modules/es.array.iterator");

var curry = require("./curry.js");

module.exports = curry(function curryN(n, f) {
  return function _recur(a, ..._) {
    return _.length >= n ? f(a, ..._) : (...__) => _recur(a, ..._, ...__);
  };
});